(function (app, ng) {

    app.component("configureDiscloseWorkflow",
        {
            controller: configureDiscloseWorkflowController,
            templateUrl: "/App/Dashboard/ConfigureTransactionGroup/Workflows/Disclose/template.html",
            bindings: {
                transactionGroup: "=",
                publishedTransactionGroup: "<",
                disclosePoints: "=",
                disclosures: "=",
                onSave: "&"
            }
        });

    configureDiscloseWorkflowController.$inject = [
        "$window", "$q", "_", "figToaster", "figToastContainers", "transactionGroupApi",
        "disclosureApi", "$scope"
    ];

    function configureDiscloseWorkflowController($window, $q, _, figToaster, figToastContainers,
        transactionGroupApi, disclosureApi, $scope) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                UI: {
                    selectedDisclosePoint: "Entity"
                },
                disclosePoints: [
                    { Type: "Agent", ShortType: "Agent", Description: "Generated during transaction initiation", IsActive: false },
                    { Type: "Entity", ShortType: "Entity", Description: "Upload the disclosures for your entity", IsActive: false },
                    { Type: "Other Entities", ShortType: "OtherEntities", Description: "Pull disclosures for all entities in workflow", IsActive: false }
                ],
                addDisclosures: addDisclosures,
                updateDisclosePoints: updateDisclosePoints,
                removeDisclosure: removeDisclosure,
                updateDisclosure: updateDisclosure,
                updateTransactionGroup: updateTransactionGroup,
                updateTransactionGroupDisclosures: updateTransactionGroupDisclosures,
                viewPdf: viewPdf
            });

        this.$onInit = function () {
            var tmpDisclosePoints = [];
            ng.forEach($ctrl.transactionGroup.DisclosePoints,
                function (transactionGroupDisclosePoint) {
                    var index = 0;
                    ng.forEach($ctrl.disclosePoints,
                        function (disclosePoint) {
                            if (disclosePoint.ShortType === transactionGroupDisclosePoint) {
                                $ctrl.disclosePoints.splice(index, 1);
                                tmpDisclosePoints.push(disclosePoint);
                                return;
                            }
                            index++;
                        });
                });

            tmpDisclosePoints = tmpDisclosePoints.concat($ctrl.disclosePoints);
            $ctrl.disclosePoints = tmpDisclosePoints;

            ng.forEach($ctrl.disclosePoints,
                function (disclosurePoint) {
                    var type = _.find($ctrl.transactionGroup.DisclosePoints,
                        function (transactionGroupDisclosurePoint) {
                            return transactionGroupDisclosurePoint === disclosurePoint.ShortType;
                        });

                    disclosurePoint.IsActive = !!type;
                });

            var unpublished = [];
            if ($ctrl.publishedTransactionGroup && $ctrl.transactionGroup) {
                ng.forEach($ctrl.transactionGroup.DisclosePoints, function (point) {
                    if (!_.find($ctrl.publishedTransactionGroup.DisclosePoints, function (p) {
                        return p === point;
                    })) {
                        unpublished.push(point);
                    }
                });

                ng.forEach($ctrl.publishedTransactionGroup.DisclosePoints, function (point) {
                    if (!_.find($ctrl.transactionGroup.DisclosePoints, function (p) {
                        return p === point;
                    })) {
                        unpublished.push(point);
                    }
                });

                ng.forEach(unpublished, function (a) {
                    _.find($ctrl.disclosePoints, function (p) {
                        return a === p.ShortType;
                    }).Unpublished = true;
                });

                ng.forEach($ctrl.transactionGroup.disclosures, function (disclosure) {
                    if (!_.find($ctrl.publishedTransactionGroup.disclosures, function (d) {
                        return d === disclosure;
                    })) {
                        var disclose = _.find($ctrl.disclosures, function (row) {
                            return row.Id = disclosure;
                        });
                        if (disclose)
                            disclose.Unpublished = true;
                    }
                });
            } else {
                ng.forEach($ctrl.disclosePoints, function (point) {
                    if (!point.IsActive)
                        point.Unpublished = true;
                });
            }
        };

        function addDisclosures(files) {
            var promises = [];

            ng.forEach(files,
                function (file) {
                    var disclosure = {
                        Title: "Disclosure " + ($ctrl.disclosures.length + 1),
                        FileName: file.name,
                        Unpublished: true
                    };
                    $ctrl.disclosures.push(disclosure);

                    var payload = new FormData();
                    payload.append("disclosure", file, file.name);
                    payload.append("title", disclosure.Title);

                    promises.push(disclosureApi.add(payload).then(function (response) {
                        disclosure.Id = response.Id;
                        updateUnpublishedChanges(disclosure);
                    }));
                });

            $q.all(promises).then(function () {
                transactionGroupApi.updateDisclosures($ctrl.transactionGroup, $ctrl.disclosures);
                transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
            });
        }

        function removeDisclosure(disclosure, index) {
            figToaster.showYesNo("Are you sure you would like to delete " + disclosure.Title + "?",
                "bottom center",
                figToastContainers.get("configure-transaction-group"),
                true).then(function (response) {
                if (!response) return;

                $ctrl.disclosures.splice(index, 1);
                disclosureApi.delete(disclosure.Id).then(function () {
                    transactionGroupApi.updateDisclosures($ctrl.transactionGroup, $ctrl.disclosures).then(function() {
                        updateUnpublishedChanges(disclosure);
                        transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
                    });
                });
            });
        }

        function updateDisclosure(disclosure) {
            disclosureApi.update(disclosure.Id, disclosure).then(function () {
                disclosure.Unpublished = !disclosure.Unpublished;
                updateUnpublishedChanges(disclosure);
                transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
            });
        }

        function updateTransactionGroupDisclosures() {
            transactionGroupApi.updateDisclosures($ctrl.transactionGroup, $ctrl.disclosures);
        }

        function updateTransactionGroup() {
            $ctrl.transactionGroup.DisclosePoints = [];
            ng.forEach($ctrl.disclosePoints,
                function (disclosePoint) {
                    if (disclosePoint.IsActive)
                        $ctrl.transactionGroup.DisclosePoints.push(disclosePoint.ShortType);
                });
            transactionGroupApi.update($ctrl.transactionGroup.Id, $ctrl.transactionGroup);
        }

        function updateDisclosePoints(point) {
            point.Unpublished = !point.Unpublished;
            updateUnpublishedChanges(point);
            updateTransactionGroup();
        }

        function viewPdf(disclosure) {
            disclosureApi.get(disclosure.Id).then(function (response) {
                var url = URL.createObjectURL(response);

                $window.open(url, response.FileName);
            });
        }

        function updateUnpublishedChanges(item) {
            if (item.Unpublished === true)
                $ctrl.transactionGroup.UnpublishedChanges++;
            else
                $ctrl.transactionGroup.UnpublishedChanges--;
        }
    };
})(window.app, window.angular); // jshint ignore:line